import React from 'react';

const Header = ({ onRefresh, isRefreshing }) => {
  return (
    <div className="header">
      <h1>📚 Bookmarked Queries</h1>
      <p>Your saved questions and responses</p>
      <button 
        className="refresh-btn"
        onClick={onRefresh}
        disabled={isRefreshing}
      >
        🔄 {isRefreshing ? 'Refreshing...' : 'Refresh Bookmarks'}
      </button>
    </div>
  );
};

export default Header;